﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class CategoriaUserComponent {

    tabla: Tabla = {
        titulo: 'Categorias',
        endPoint:'/rest-api/user/categoria',
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Categoria',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Suma Puntos',
                prop: 'sumaPuntos',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };

}
